import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import { useAutoApply } from 'builder/views/AutoApply/hooks/useAutoApply'
import { actions as jobSearchActions } from 'builder/modules/jobSearch'

const RECOMMENDED_JOBS = '/job-search?view=recommendation'

export const useRedirectToAutoApply = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { redirectToAutoApplyQuestionnaire, redirectToBillingPlans } = useAutoApply()

  const redirectToAutoApply = useCallback(() => {
    if (redirectToBillingPlans()) return
    if (redirectToAutoApplyQuestionnaire()) return

    dispatch(jobSearchActions.startAutoApplyBubble({ enableFirstPage: true }))
    navigate(RECOMMENDED_JOBS)
  }, [dispatch, redirectToAutoApplyQuestionnaire, navigate, redirectToBillingPlans])

  return { redirectToAutoApply }
}
